import { useContext } from "react";
import { GeoAppContext } from "../../App";

export const getAppContext = () => {
  return useContext(GeoAppContext);
};

export const resetStore = (client: any) => {
  // resets all apollo data, refreshees whoe app same time
  if (client) {
    client.resetStore();
  }
};
